<h1 mat-dialog-title>
  Rename CV
  <button (click)="cancelDialog()" class="close-btn" isIconButton="true" mat-button>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</h1>
<form [formGroup]="renameForm" (ngSubmit)="submitDialog()" name="renameForm" novalidate>
  <div class="flex flex-col" mat-dialog-content>
    <section>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>New CV name</mat-label>
        <input
          cdkFocusInitial
          class="form-control"
          formControlName="CvName"
          matInput
          maxlength="{{ ICV_MAX_LENGTHS.CvName }}"
          name="cvName"
          placeholder="e.g. Resume for 7N"
          type="text"
        />
        <mat-error
          [field]="renameForm.get('CvName')"
          [messages]="['required', 'maxlength']"
          [texts]="{ required: 'Enter a CV name' }"
        ></mat-error>
      </mat-form-field>
    </section>
  </div>
  <div mat-dialog-actions>
    <button class="small-button" color="accent" mat-flat-button type="submit">Rename CV</button>
    <button (click)="cancelDialog()" class="small-button" color="primary" mat-button type="button">Cancel</button>
  </div>
</form>
